import { MappedClass, MappedProperty, MappedPropertyDate } from '@h5s/util-object';
import { DateTime } from 'luxon';

@MappedClass()
export class SendPsCustomer {
  @MappedPropertyDate()
  date: DateTime;

  @MappedProperty()
  ownerPublicSecurityId: number;

  @MappedProperty()
  purchasedStayToCustomerIdsToInclude: number[];

  constructor(init?: Partial<SendPsCustomer>) {
    Object.assign(this, init);
  }
}
